/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import AWS from 'aws-sdk';
import {AuthenticationDetails, CognitoUserPool, CognitoUserAttribute, CognitoUser} from 'amazon-cognito-identity-js';

import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import UserStore from '../stores/UserStore';

import Config from '../api/config';

const PoolIdentifier = Config[process.env.REACT_APP_ENVIRONMENT].poolIdentifier;
const ClientIdentifier = Config[process.env.REACT_APP_ENVIRONMENT].clientIdentifier;
const IdentityPoolId = Config[process.env.REACT_APP_ENVIRONMENT].identityPoolId;
const Region = Config[process.env.REACT_APP_ENVIRONMENT].poolRegion;

const PoolData = {UserPoolId: PoolIdentifier, ClientId: ClientIdentifier};

class AuthenticationClass {

    constructor() {
        AWS.config.update({region: Region});
    }

    createUser(email, name, password, role, onSuccess, onFailure) {
        console.log("[COGNITO] - creating user : " + email);
        var userPool = new CognitoUserPool(PoolData);

        var attributeList = [];
        var dataEmail = {Name: 'email', Value: email};
        var dataName = {Name: 'name', Value: name};

        var attributeEmail = new CognitoUserAttribute(dataEmail);
        var attributeName = new CognitoUserAttribute(dataName);

        attributeList.push(attributeEmail);
        attributeList.push(attributeName);

        console.log("[COGNITO] - signing up user");
        userPool.signUp(email, password, attributeList, null, function (err, result) {
            if (err) {
                onFailure(err);
                return;
            }
            console.log("[COGNITO] - succcessful user signup");
            onSuccess(result.user);
        });
    }


    confirmUser(username, confirmationNumber, onSuccess, onFailure) {
        var userPool = new CognitoUserPool(PoolData);
        var userData = {Username: username, Pool: userPool};

        var cognitoUser = new CognitoUser(userData);
        cognitoUser.confirmRegistration(confirmationNumber, true, function (err, result) {
            if (err) {
                onFailure(err);
                return;
            }
            console.log('[COGNITO] user confirmation: ' + result);
            onSuccess(result);
        });
    }

    login(user, pwd, handler) {
        console.log("[COGNITO] - Logging in user :" + user + " pwd: " + pwd);
        let authData = {Username: user, Password: pwd};
        let authDetails = new AuthenticationDetails(authData);

        var userPool = new CognitoUserPool(PoolData);
        var userData = {Username: user, Pool: userPool};
        let cognitoUser = new CognitoUser(userData);

        var SuccessHandler = (result) => {
            console.log("[COGNITO] - SUCCESSFUL LOGIN");
            console.log('access token + ' + result.getAccessToken().getJwtToken());

            var authResult = result;
            var prefName = "";
            cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                    handler.failure(err);
                    return;
                }

                var attributes = {};
                for (var i = 0; i < result.length; i++) {
                    console.log('[COGNITO] attribute ' + result[i].getName() + ' has value ' + result[i].getValue());
                    attributes[result[i].getName()] = result[i].getValue();
                }

                UserStore.setUserAttributes(attributes);
                Authentication.setCredentials(authResult.getIdToken().getJwtToken());
                handler.success(cognitoUser);
            });

        };
        var FailureHandler = (err) => {
            console.log("[COGNITO] ERROR in login: " + err);
            handler.failure(err);
        };

        cognitoUser.authenticateUser(authDetails, {
            onSuccess: SuccessHandler,
            onFailure: FailureHandler,
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                // User was signed up by an admin and must provide new
                // password and required attributes, if any, to complete
                // authentication.

                var newPassword = prompt('Enter new password', '');
                cognitoUser.completeNewPasswordChallenge(newPassword, {}, {
                    onSuccess: SuccessHandler,
                    onFailure: FailureHandler
                });
            }
        });
    }

    resetPassword(userName, handler) {
        var userPool = new CognitoUserPool(PoolData);
        var userData = {Username: userName, Pool: userPool};

        let cognitoUser = new CognitoUser(userData);
        cognitoUser.changePassword(this.state.password, this.state.newPassword, function (err, result) {
            if (err) {
                handler.failure(err);
                return;
            }
            handler.success(result);
        });
    }

    currentUser() {
        let userPool = new CognitoUserPool(PoolData);
        return userPool.getCurrentUser();
    }

    getSession() {
        return new Promise((resolve, reject) => {
            let userPool = new CognitoUserPool(PoolData);
            let cognitoUser = userPool.getCurrentUser();

            if (cognitoUser != null) {
                cognitoUser.getSession((err, session) => {
                    if (err) {
                        Authentication.logout();
                        reject("Not authorised");
                        return;
                    }
                    UserStore.notify();
                    Authentication.setCredentials(session.getIdToken().getJwtToken());
                    resolve(session.getIdToken().getJwtToken());
                });
            } else {
                Authentication.logout();
                reject("Not authorised");
            }
        });
    }

    logout() {
        let userPool = new CognitoUserPool(PoolData);
        let cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
            cognitoUser.signOut();
        }

        AppDispatcher.handleViewAction({actionType: AppConstants.USER_LOGOUT});
    }

    /* Helper Functions */
    setCredentials(token) {
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: IdentityPoolId,
            Logins: {}
        });
        let loginId = 'cognito-idp.${Region}.amazonaws.com/${PoolIdentifier}';
        console.log("[AUTH] - set credential token=", token);
        AWS.config.credentials.params.Logins[loginId] = token;
    }

    getCredentials() {
        return AWS.config.credentials;
    }

    getAuthorisation(t) {
        return new Promise((resolve, reject) => {
            let loginId = 'cognito-idp.${Region}.amazonaws.com/${PoolIdentifier}';
            // let loginId = 'cognito-idp.us-east-1.amazonaws.com/us-east-1_MZfl3NXxa';
            resolve(AWS.config.credentials.params.Logins[loginId]);
            // resolve(AWS.config.credentials);
        });
    }
}

const Authentication = new AuthenticationClass();
export default Authentication;





// WEBPACK FOOTER //
// ./src/app/authentication/awsAuthentication.js